<template>
  <div class="btnitem" @click="toChat">
    <img style="width:19px;height:19px" src="@/assets/linshiyonggong/kefu@2x.png"/>
    <span>交流</span>
  </div>
</template>

<script>
import axios from "@/http"
import eventBus from "@/utils/event-bus"
import { mapState } from "vuex"
import {checkDataStatus} from "@/utils/checkDataStatus"
import { apiWorker } from "@/api/apiWorker"
export default {
  name: "im",
  props:{
    item:{
      type:Object,
      default(){
        return {}
      }
    },
    type: {
      type: [Number,String] // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工 7班组找活
    }
  },
  data(){
    return {
      loading:false
    }
  },
  computed: {
    ...mapState({
      userNo: state => state.user.no,
      companyNo: state => state.user.companyNo
    })
  },
  methods:{
    // 交流
    async toChat() {
      if(this.permissionTips({realName:false})) return
      const dataState = await checkDataStatus(this.type,this.item.no)
      if(!dataState){
        this.$message.error('系统异常，请稍后再试')
        return
      }
      if(dataState!=1){
        this.$emit('changeStatus',dataState)
        return
      }
      let item=this.item;
        //临时用工判断是否已删除
        if(this.type==4){
          let obj=item;
          if(!obj.isDeleted&&this.$parent.$parent&&this.$parent.$parent.getDetailapi){
            obj=await this.$parent.$parent.getDetailapi();
          }
          if(!obj||obj.isDeleted){
            this.$message.error("该用工不存在！")
            return
          }
        }
        if (item.companyNo === this.$parent.companyNo||(item.teamNo&&item.teamNo === this.$parent.teamNo)||item.teamRoleNo === this.$parent.teamNo) {
        this.$message.error("操作失败，不能对同企业/团队发布的内容进行该操作")
        return
      }
        if (item.userNo === this.userNo || item.user_no === this.userNo||item.createUserNo === this.$parent.userNo) {
          this.$message.error("操作失败，不能对自己发布的内容进行该操作")
          return
        }else if (item.imId) {//选择了客服
         if(this.type==7){
            eventBus.$emit("sendImMessage", item.imId)
          }else{
            axios
              .get(`${process.env.VUE_APP_COMPANY}/v1/organization/getUser/${item.imId}`)
              .then(res => {
                if (res.data.code === 200) {
                  if (res.data.data.imAccount) {
                    eventBus.$emit("sendImMessage", res.data.data.imAccount)
                  } else {
                    this.$message.error("未找到客服人员")
                  }
                } else {
                  this.$message.error(res.data.msg)
                }
              })
          }
        }else if (item.userNo && !item.imId) {//未选择客服就与发布人交流
        let { data } = await apiWorker.getfindUserByNo(item.userNo)
        if (data.code === 200) {
          if (data.data.imAccount) {
            eventBus.$emit("sendImMessage", data.data.imAccount)
          } else {
            this.$message.error("未找到客服人员")
          }
        } else {
          this.$message.error(data.msg)
        }
      }else {
        this.$message.error("未找到客服人员")
        }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
